import { memo } from "react";
import * as Styled from "./style";
import { SamplePackageImage } from "~/components/blocks/common/sample-package-image";
import { SamplePlayer } from "~/components/blocks/product/detail/sample-player";
import { SampleVisualImage } from "~/components/blocks/product/detail/sample-visual-image";
import { useImageSrcFormat } from "~/hooks/use-image-src-format";
import { useMatchMedia } from "~/hooks/use-match-media";
import { useRatingBlock } from "~/hooks/use-rating-block";
import type { G_SampleMovie, G_VideoRatingCategory, Maybe } from "~/lib/graphql";

type SampleLegacyAssetProps = {
  sampleMovie: Maybe<G_SampleMovie> | undefined;
  packageLargeImage: Maybe<string> | undefined;
  packageImage: string;
  videoRatingCategory: G_VideoRatingCategory;
};

export const SampleLegacyAsset = memo((props: SampleLegacyAssetProps) => {
  const { sampleMovie, packageLargeImage, packageImage, videoRatingCategory } = props;

  const { isSpSize } = useMatchMedia();
  const { imageSrcFormat } = useImageSrcFormat({ aspectRatio: "LANDSCAPE" });

  /** SP以外かつサンプル動画の情報がある場合、サンプル動画を表示する */
  const isSamplePlayer = !isSpSize && sampleMovie !== undefined && sampleMovie !== null;

  const { disallowAutoPlaySampleMovie } = useRatingBlock();
  const canShowSampleMovie = isSamplePlayer && !disallowAutoPlaySampleMovie(videoRatingCategory);

  if (canShowSampleMovie) {
    return (
      <SamplePlayer
        src={[{ uri: sampleMovie.url }]}
        posterImage={
          imageSrcFormat({ imgSrc: packageLargeImage || packageImage, size: { w: 1920, h: 1080 } }).alternativeSrc
        }
      />
    );
  }

  if (packageLargeImage) {
    return (
      <>
        <SampleVisualImage
          {...imageSrcFormat({ imgSrc: packageLargeImage, size: { w: 1920, h: 1080 } })} // HACK: スマホサイズ時に容量を多く消費する可能性あり。画像小さくする
          alt="パッケージ画像"
        />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  if (packageImage) {
    return (
      <>
        <SamplePackageImage packageImageUrl={packageImage} />
        <Styled.VideoForSeoOptimization />
      </>
    );
  }

  return null;
});

SampleLegacyAsset.displayName = "SampleLegacyAsset";
